export default __webpack_public_path__ + "static/media/laborEdge.0a8bc444.png";